import React from 'react';
import WarningLightsIcon from 'mdi-react/WarningLightsIcon';
import AlertDecagramOutlineIcon from 'mdi-react/AlertDecagramOutlineIcon';
import AlarmLightIcon from 'mdi-react/AlarmLightIcon'
import RunIcon from 'mdi-react/RunIcon'


export const Icons = ({ health_score }) => {
    if (health_score < 1000){
        return <WarningLightsIcon />;
    } else  if (health_score < 3000){
        return <AlarmLightIcon />;
    } else  if (health_score < 5000){
        return <AlertDecagramOutlineIcon />;
    } else {
        return <RunIcon />;
    }
}
